import { merge } from 'lodash';

import { loggedInUserDataStore } from '../../../stores/loggedInUserDataStore';
import { ANGULAR_EVENT_KEYS } from '../../../constants/system/ANGULAR_EVENT_KEYS';
import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { broadcastEvent } from '../../angularUtils';
import { LoggedInUser } from '../../../interfaces/LoggedInUser';
import { DeepPartial } from '../../../../utils-types';

export const updateUserInfo = (newLoggedInUserData: DeepPartial<LoggedInUser>) => {
  const userData = merge({}, loggedInUserDataStore.loggedInUser, newLoggedInUserData);

  localStorage.setItem(LOCAL_STORAGE_KEYS.LOGGED_IN_USER, JSON.stringify(userData));

  loggedInUserDataStore.setLoggedInUser(); // get data from localStorage

  broadcastEvent(ANGULAR_EVENT_KEYS.UPDATE_USER);
};
